/**
 * Route for `platform-fee-bank`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PlatformFeeBankPage } from "../features/platform-fee-bank/PlatformFeeBankPage";

export const platformFeeBankRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/platform-fee-bank",
	component: PlatformFeeBankPage,
});

export default platformFeeBankRoute;
